import { fromNullable } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import { emptyFragment } from '../../../../EmptyFragment';
import { T } from '../../../../Translations';

interface Props {
  values: ReadonlyArray<string>;
  none: React.ReactElement;
}

const Overflow = ({ rest }: { rest: ReadonlyArray<string> }) =>
  rest.length > 0 ? (
    <span
      className="flex-shrink-0 px-1.5 py-0.5 text-muted-foreground"
      style={{ fontSize: 'var(--text-xs)' }}
      title={rest.join(', ')}
    >
      <span aria-hidden="true">
        <T kind="+{{remaining}}" remaining={rest.length} />
      </span>
      <span className="sr-only">{rest.join(', ')}</span>
    </span>
  ) : (
    emptyFragment()
  );

/**
 * One chip plus "+N", so a person in eight groups doesn't blow out the row.
 * The full list is in the "+N" tooltip until the person drawer lands.
 */
function MultiValueCell({ values, none }: Props) {
  const [first, ...rest] = values;

  return fromNullable(first)
    .map((value) => (
      <div className="flex min-w-0 items-center gap-1.5">
        <span
          className="max-w-[150px] truncate rounded-md border border-border bg-muted px-2 py-0.5 text-foreground"
          style={{ fontSize: 'var(--text-xs)' }}
          title={value}
        >
          {value}
        </span>
        <Overflow rest={rest} />
      </div>
    ))
    .getOrElse(() => none);
}

export default observer(MultiValueCell);
